import React from "react";
import PropTypes from "prop-types";
import AppChrome from "./AppChrome";

const SignupLayout = ({ children, noNavbar = false }) => (
  <AppChrome noNavbar={noNavbar}>{children}</AppChrome>
);

SignupLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

export default SignupLayout;
